import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { VideocallRoom } from './videocall-room.interface';
import { VideocallRoomService } from './videocall-room.service';

const service = new VideocallRoomService();

export interface VideocallRoomState {
   videocallRooms: Array<VideocallRoom>;
}

const VideocallRoomStore: Module<VideocallRoomState, StoreState> = {
   namespaced: true,
   state: {
      videocallRooms: [],
   },
   getters: {},
   mutations: {
      SET_VIDEOCALL_ROOMS(state, videocallRooms: Array<VideocallRoom>) {
         state.videocallRooms = videocallRooms;
      },
   },
   actions: {
      async getVideocallRooms(context, teamId: number) {
         const response = await service.getVideocallRooms(teamId);
         context.commit('SET_VIDEOCALL_ROOMS', response.data);
         return response.data;
      },
      async deleteVideocallRoom(context, payload: { teamId: number; videocallRoomId: number }) {
         const response = await service.deleteVideocallRoom(payload.teamId, payload.videocallRoomId);
         return response.data;
      },
      async postVideocallRoom(context, payload: { teamId: number; videocallRoom: VideocallRoom }) {
         const response = await service.postVideocallRoom(payload.teamId, payload.videocallRoom);
         return response.data;
      },
      async putVideocallRoom(context, payload: { teamId: number; videocallRoom: VideocallRoom }) {
         const response = await service.putVideocallRoom(payload.teamId, payload.videocallRoom);
         return response.data;
      },
   },
};

export default VideocallRoomStore;
